import { Dive } from '../types/Dive';

export interface DemoDataset {
  dives: Dive[];
  exportDate: string;
  version: string;
}

// Sample diving data for demonstration purposes
export const DEMO_DATA: DemoDataset = {
  dives: [
    {
      id: "demo-dive-1",
      activityId: "demo-1",
      startTime: "2024-12-15T09:30:00Z",
      endTime: "2024-12-15T10:15:00Z",
      duration: "00:45:00",
      maxDepth: 18.5,
      avgDepth: 12.3,
      waterTemperature: 26.5,
      diveType: "Scubadiving",
      location: "-16.2839°, 145.7781°",
      latitude: -16.2839,
      longitude: 145.7781,
      diveProfile: [
        { time: "00:00:00", depth: 0, temperature: 26.5 },
        { time: "00:05:00", depth: 8.2, temperature: 26.2 },
        { time: "00:10:00", depth: 15.6, temperature: 25.8 },
        { time: "00:20:00", depth: 18.5, temperature: 25.4 },
        { time: "00:35:00", depth: 16.2, temperature: 25.6 },
        { time: "00:40:00", depth: 8.1, temperature: 26.0 },
        { time: "00:45:00", depth: 0, temperature: 26.5 }
      ],
      stats: {
        ascentRate: 8.5,
        descentRate: 12.3,
        safetyStopTime: 180,
        bottomTime: 1800,
        visibility: "Excellent"
      }
    },
    {
      id: "demo-dive-2",
      activityId: "demo-2",
      startTime: "2024-12-14T14:20:00Z",
      endTime: "2024-12-14T14:55:00Z",
      duration: "00:35:00",
      maxDepth: 23.2,
      avgDepth: 18.7,
      waterTemperature: 24.8,
      diveType: "Freediving",
      location: "17.3167°, -87.5333°",
      latitude: 17.3167,
      longitude: -87.5333,
      diveProfile: [
        { time: "00:00:00", depth: 0, temperature: 24.8 },
        { time: "00:02:00", depth: 12.5, temperature: 24.5 },
        { time: "00:04:00", depth: 23.2, temperature: 24.1 },
        { time: "00:06:00", depth: 18.9, temperature: 24.3 },
        { time: "00:30:00", depth: 15.6, temperature: 24.4 },
        { time: "00:35:00", depth: 0, temperature: 24.8 }
      ],
      stats: {
        ascentRate: 15.2,
        descentRate: 18.7,
        safetyStopTime: 0,
        bottomTime: 1200,
        visibility: "Good"
      }
    },
    {
      id: "demo-dive-3",
      activityId: "demo-3",
      startTime: "2024-12-13T11:45:00Z",
      endTime: "2024-12-13T12:30:00Z",
      duration: "00:45:00",
      maxDepth: 15.8,
      avgDepth: 9.2,
      waterTemperature: 28.2,
      diveType: "Snorkeling",
      location: "Maldives, Indian Ocean",
      latitude: 3.2028,
      longitude: 73.2207,
      diveProfile: [
        { time: "00:00:00", depth: 0, temperature: 28.2 },
        { time: "00:10:00", depth: 3.5, temperature: 28.1 },
        { time: "00:20:00", depth: 6.8, temperature: 27.9 },
        { time: "00:25:00", depth: 15.8, temperature: 27.5 },
        { time: "00:40:00", depth: 4.2, temperature: 28.0 },
        { time: "00:45:00", depth: 0, temperature: 28.2 }
      ],
      stats: {
        ascentRate: 6.2,
        descentRate: 8.5,
        safetyStopTime: 0,
        bottomTime: 2100,
        visibility: "Excellent"
      }
    },
    {
      id: "demo-dive-4",
      activityId: "demo-4",
      startTime: "2024-12-12T08:15:00Z",
      endTime: "2024-12-12T09:05:00Z",
      duration: "00:50:00",
      maxDepth: 28.4,
      avgDepth: 22.1,
      waterTemperature: 22.1,
      diveType: "Scubadiving",
      location: "Cenote Dos Ojos, Mexico",
      latitude: 20.3242,
      longitude: -87.3381,
      diveProfile: [
        { time: "00:00:00", depth: 0, temperature: 22.1 },
        { time: "00:08:00", depth: 15.2, temperature: 21.8 },
        { time: "00:15:00", depth: 25.6, temperature: 21.5 },
        { time: "00:25:00", depth: 28.4, temperature: 21.2 },
        { time: "00:40:00", depth: 18.9, temperature: 21.6 },
        { time: "00:45:00", depth: 5.2, temperature: 21.9 },
        { time: "00:50:00", depth: 0, temperature: 22.1 }
      ],
      stats: {
        ascentRate: 9.8,
        descentRate: 11.2,
        safetyStopTime: 300,
        bottomTime: 2400,
        visibility: "Good"
      }
    },
    {
      id: "demo-dive-5",
      activityId: "demo-5",  
      startTime: "2024-12-11T16:30:00Z",
      endTime: "2024-12-11T17:15:00Z",
      duration: "00:45:00",
      maxDepth: 21.3,
      avgDepth: 16.8,
      waterTemperature: 19.5,
      diveType: "Spearfishing",
      location: "Poor Knights Islands, New Zealand", 
      latitude: -35.4833,
      longitude: 174.7333,
      diveProfile: [
        { time: "00:00:00", depth: 0, temperature: 19.5 },
        { time: "00:05:00", depth: 8.9, temperature: 19.2 },
        { time: "00:12:00", depth: 18.5, temperature: 18.8 },
        { time: "00:20:00", depth: 21.3, temperature: 18.5 },
        { time: "00:35:00", depth: 14.2, temperature: 18.9 },
        { time: "00:42:00", depth: 6.1, temperature: 19.3 },
        { time: "00:45:00", depth: 0, temperature: 19.5 }
      ],
      stats: {
        ascentRate: 10.5,
        descentRate: 13.8,
        safetyStopTime: 180,
        bottomTime: 1800,
        visibility: "Fair"
      }
    },
    {
      id: "demo-dive-6",
      activityId: "demo-6",
      startTime: "2024-12-10T13:20:00Z", 
      endTime: "2024-12-10T14:00:00Z",
      duration: "00:40:00",
      maxDepth: 12.7,
      avgDepth: 8.4,
      waterTemperature: 25.8,
      diveType: "Mermaiding",
      location: "Channel Islands, California",
      latitude: 34.0133,
      longitude: -119.4077,
      diveProfile: [
        { time: "00:00:00", depth: 0, temperature: 25.8 },
        { time: "00:08:00", depth: 5.2, temperature: 25.6 },
        { time: "00:15:00", depth: 10.1, temperature: 25.2 },
        { time: "00:22:00", depth: 12.7, temperature: 24.9 },
        { time: "00:35:00", depth: 7.3, temperature: 25.4 },
        { time: "00:40:00", depth: 0, temperature: 25.8 }
      ],
      stats: {
        ascentRate: 7.2,
        descentRate: 9.1,
        safetyStopTime: 0,
        bottomTime: 1800,
        visibility: "Good"
      }
    }
  ],
  exportDate: "2024-12-15T10:00:00Z",
  version: "1.0.0"
};